import React from 'react';

const MagnifyingGlasses = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>((props, ref) => (
  <svg viewBox="0 0 1000 666.667" {...props} ref={ref}>
    <g clipPath="url(#a)" transform="matrix(1.33333 0 0 -1.33333 0 666.667)">
      <path
        d="M580.7 432.5c79.86 0 144.6-64.74 144.6-144.6s-64.74-144.6-144.6-144.6-144.601 64.74-144.601 144.6S500.84 432.5 580.7 432.5"
        fill="#bbf0fe"
      />
      <path
        d="M680.2 180.2c-83.8 27.6-129.4 118-101.9 201.9 7 20.9 17.7 39.6 31.299 55.1C673.9 422.7 718.4 369.5 722.9 313.3c5.1-66-36.801-135.3-42.7-133.1"
        fill="#d9f8ff"
      />
      <path
        d="M450 137.7 382 29.599c-1.6-2.5 6.6-10.699 18.4-18.099 11.8-7.3 22.7-11.3 24.3-8.8l68 108.1z"
        fill="#02b4e2"
      />
      <path
        d="M450 137.7 382 29.599c-1.4-2.299 4.8-8.799 14.3-15.399-2 3.6-2.7 7.5-.4 11.5 6.8 10.899 54.2 86.1 65.9 104.7z"
        fill="#0d97bc"
      />
      <path
        d="M450.183 137.828c1.617 2.572 12.479-1.349 24.263-8.757 11.782-7.408 20.023-15.499 18.406-18.07-1.617-2.572-12.48 1.348-24.262 8.758-11.783 7.408-20.023 15.498-18.407 18.069"
        fill="#66d6e2"
      />
      <path
        d="M514.1 166.2c-64.1 40.3-83.399 124.9-43.1 189 40.3 64.1 124.901 83.4 189 43.1 64.1-40.3 83.401-124.9 43.1-189-40.3-64.201-124.899-83.4-189-43.1M673.8 420c-76.099 48-176.7 24.9-224.7-51.2s-24.899-176.701 51.2-224.701C576.401 96.099 677 119.3 725 195.4s24.8 176.8-51.2 224.6"
        fill="#0d97bc"
      />
      <path
        d="m482.6 172.5-24.199-38.3c-1.101-1.6 4.3-6.8 11.8-11.6 7.5-4.8 14.5-7.3 15.599-5.7l24.2 38.3z"
        fill="#adb5bc"
      />
      <path d="m492.1 166.6-9.5 5.9-24.199-38.299c-.901-1.3 2.5-5 7.699-8.8z" fill="#777f87" />
      <path
        d="M502.3 173.5c-64.1 40.3-83.399 124.9-43.1 189 40.3 64.1 124.9 83.4 189 43.1 64.1-40.3 83.4-124.9 43.1-189-40.3-64-124.899-83.3-189-43.1M662 427.6c-76.099 48-176.7 24.9-224.7-51.2s-24.899-176.7 51.2-224.7c76.1-48 176.7-24.9 224.7 51.2s25 176.7-51.2 224.7"
        fill="#00c2e8"
      />
    </g>
    <g clipPath="url(#b)" transform="matrix(1.33333 0 0 -1.33333 0 666.667)">
      <path
        d="M169.3 476.2c79.86 0 144.6-64.74 144.6-144.6S249.16 187 169.3 187 24.7 251.74 24.7 331.6s64.74 144.6 144.6 144.6"
        fill="#bbf0fe"
      />
      <path
        d="M78 463.7c90.8-59.6 116.2-181.3 56.6-272.3-8.1-12.2-96 51.699-110.3 129.1-12.2 66.1 48 147 53.7 143.2"
        fill="#d9f8ff"
      />
      <path
        d="m236.3 148.5 55.9-114.9c1.3-2.7 12.5 0 25.1 6.1 12.5 6.1 21.7 13.2 20.4 15.9l-55.9 114.9Z"
        fill="#02b4e2"
      />
      <path
        d="m236.3 148.5 55.9-114.9c1.1-2.3 10-.5 20.6 3.9-4.1.2-7.9 1.6-9.8 5.7-5.5 11.6-44.4 91.5-54.1 111.3Z"
        fill="#0d97bc"
      />
      <path
        d="M256.602 164.538c12.521 6.076 23.748 8.787 25.074 6.054 1.326-2.733-7.75-9.874-20.271-15.95-12.522-6.078-23.748-8.788-25.074-6.055-1.326 2.733 7.75 9.875 20.271 15.951"
        fill="#66d6e2"
      />
      <path
        d="M222.8 205.6c-68-33.1-150.2-4.699-183.1 63.5-32.9 68.2-4.6 150.2 63.6 183.2s150.2 4.7 183.1-63.5c32.9-68.099 4.5-150.3-63.6-183.2m-131 269.8C10.9 436.1-22.9 338.6 16.4 257.701 55.7 176.8 153.2 143 234.1 182.3 315 221.6 348.9 319.1 309.5 400c-39.2 80.9-136.8 114.701-217.7 75.4"
        fill="#0d97bc"
      />
      <path d="m223.9 194.5 19.9-40.8c.9-1.8 8.1 0 16.1 3.9 8.1 3.9 14 8.4 13.1 10.2l-19.9 40.8Z" fill="#adb5bc" />
      <path d="m234.1 199.3-10-4.8 19.9-40.8c.7-1.4 5.5-.5 11.5 1.8z" fill="#777f87" />
      <path
        d="M233.6 211.8c-68-33.1-150.2-4.7-183.1 63.5-32.9 68.2-4.7 150.3 63.5 183.2 68.2 32.9 150 4.5 183.1-63.5 33-68 4.7-150.2-63.5-183.2M102.5 481.6C21.6 442.4-12.2 344.9 27.2 263.9c39.4-80.999 136.8-114.7 217.7-75.4 80.9 39.3 114.7 136.8 75.4 217.7C281 487.1 183.6 521 102.5 481.6"
        fill="#00c2e8"
      />
    </g>
  </svg>
));

export default MagnifyingGlasses;
